import { assertNever } from "@impero-com/common/utils/obj";

import type { ReportListPageType } from "./layout";

function toFromParam(pageType: ReportListPageType) {
    switch (pageType) {
        case "All":
            return "all";
        case "Status":
            return "status";
        case "Workload":
            return "workload";
        case "Classification":
            return "classification";
        case "Datasheet":
            return "datasheet";
        default:
            return assertNever(pageType);
    }
}

/** The legacy report page reads `from` to lead its breadcrumb back to this list. */
export function buildReportUrl(
    path: string,
    pageType: ReportListPageType,
    params: Record<string, string> = {}
): string {
    const search = new URLSearchParams({
        ...params,
        from: toFromParam(pageType),
    });
    return `${path}?${search.toString()}`;
}
